module.exports = __webpack_public_path__ + "img/EconomX logo - on light bg.81a83c2e.svg";